import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { IProductDataV2, Product } from '@df/catalog/product/product';
import { AbModule } from '@df/module-ab/ab.module';
import { CarouselSlideDirective } from '@df/ui-carousel/carousel-slide.directive';
import { CarouselComponent } from '@df/ui-carousel/carousel.component';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ModelCarouselComponentDef } from '../../catalog/ui/page/component/model-carousel/model-carousel.component.def';
import { getFields } from '../../catalog/ui/page/component/model-carousel/model-carousel.config';
import { ProductComponent } from '../../catalog/ui/product/product.component';

let uid = 0;

export const strapsUpsellCarouselAbConfig = {
    showFor: 'B',
    experimentName: 'basketStrapsUpsellCarousel'
};

const fields = getFields(Product.type);

fields.splice(2, 0, {
    key: 'link',
    type: NICmsContentField.EFieldType.text,
    title: 'Link'
});

@Component({
    selector: 'basket-straps-upsell-carousel',
    templateUrl: './basket-straps-upsell-carousel.html',
    styleUrl: 'basket-straps-upsell-carousel.scss',
    standalone: true,
    imports: [
        AbModule,
        CarouselComponent,
        CarouselSlideDirective,
        CommonModule,
        HrefComponent,
        ICmsClientModule,
        forwardRef(() => ProductComponent),
        SizeClassDirective,
        TranslatePipe
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<BasketStrapsUpsellCarouselComponent>({
    id: 'basket-straps-upsell-carousel',
    name: 'Straps Upsell Carousel',
    onDemandOnly: true,
    fields: fields
})
export class BasketStrapsUpsellCarouselComponent
    extends ModelCarouselComponentDef<Product<IProductDataV2>>
    implements NICmsContentComponent.IComponent
{
    readonly uid = `basket-straps-upsell-carousel${uid++}`;

    type = Product.type;

    get abShowCondition(): string {
        return `(${strapsUpsellCarouselAbConfig.experimentName}) ${strapsUpsellCarouselAbConfig.showFor}`;
    }
}
